import { useSelector, useDispatch } from 'react-redux';
import {
  setLoading,
  setScreenings,
  setCurrentScreening,
  setError,
  clearError,
  setScreeningIds,
  setScreeningData,
  setViewMode,
  setOpenAccordionIndex,
  toggleAccordion,
  clearScreeningData
} from '../ncdSlice';

export const useNCD = () => {
  const dispatch = useDispatch();
  const ncdState = useSelector(state => state.ncd);

  return {
    ...ncdState,
    setLoading: (loading) => dispatch(setLoading(loading)),
    setScreenings: (screenings) => dispatch(setScreenings(screenings)),
    setCurrentScreening: (screening) => dispatch(setCurrentScreening(screening)),
    setError: (error) => dispatch(setError(error)),
    clearError: () => dispatch(clearError()),
    setScreeningIds: (ids) => dispatch(setScreeningIds(ids)),
    setScreeningData: (type, data) => dispatch(setScreeningData({ type, data })),
    setViewMode: (mode) => dispatch(setViewMode(mode)),
    setOpenAccordionIndex: (indices) => dispatch(setOpenAccordionIndex(indices)),
    toggleAccordion: (index) => dispatch(toggleAccordion(index)),
    clearScreeningData: (key) => dispatch(clearScreeningData(key)), // 👈 added
  };
};